import { createContext, useEffect, useMemo, useState } from 'react';

type SpectrumContextType = {
  spectrum: 'light' | 'dark';
  setSpectrum: (spectrum: 'light' | 'dark') => void;
};

export const SpectrumContext = createContext<SpectrumContextType>({
  spectrum: 'light',
  setSpectrum: () => {},
});

type SpectrumProviderProps = {
  children: React.ReactNode;
};

export function SpectrumProvider({ children }: SpectrumProviderProps) {
  const [spectrum, setContextSpectrum] = useState<SpectrumContextType['spectrum']>('light');

  const setSpectrum = (updatedSpectrum: SpectrumContextType['spectrum']) => {
    localStorage.setItem('cdp-support-theme', updatedSpectrum);
    setContextSpectrum(updatedSpectrum);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('cdp-support-theme') as SpectrumContextType['spectrum'];
    if (savedTheme) setSpectrum(savedTheme);

    const htmlElement = document.documentElement;
    htmlElement?.setAttribute('data-theme', savedTheme || 'light');
  }, []);

  const value = useMemo(
    () => ({
      spectrum,
      setSpectrum,
    }),
    [spectrum],
  );

  return <SpectrumContext.Provider value={value}>{children}</SpectrumContext.Provider>;
}
